// extracted by mini-css-extract-plugin
module.exports = {"sub-copy":"SubCopy_sub-copy__syDsb","sub-copy__copy":"SubCopy_sub-copy__copy__RoUtF"};